<form
  #searchFormDiv
  [formGroup]="search_form"
  (ngSubmit)="onSubmit()"
  class="search-form row no-gutters"
  [autocomplete]="shopSearchHelper.isChrome() ? 'off' : 'on'">
  <!-- TODO: check zoomin toggle -->
  @if (toggle) {
    @if (toggleClosed) {
      <button
        type="button"
        class="btn btn-primary btn-primary-custom"
        (click)="$event.preventDefault(); toggleClosed = false">
        <span class="btn-text d-lg-inline-block mr-2">
          {{ 'SHOP_SEARCH.openForm' | alpitranslate }}
        </span>
      </button>
    }
    @if (!toggleClosed) {
      <div class="toggle-text-wrapper">
        <span class="text-header float-left">{{ 'SHOP_SEARCH.skiHire' | alpitranslate }}</span>
        <span class="float-right toggle-text c-pointer" (click)="toggleClosed = true"
          >{{ 'SHOP_SEARCH.close' | alpitranslate }}
          <app-icon name="cross" class="ml-3" />
        </span>
      </div>
    }
  }
  @if (!toggle || (toggle && !toggleClosed)) {
    <!-- poi search -->

    <app-poi-search
      (click)="maxifyForm()"
      #poiSearch
      formGroupName="poiGroup"
      [poiFormGroup]="$any(sf.poiGroup)"
      [townslug]="_bookingParameters.slug"
      [bookingParameters]="_bookingParameters"
      [platform]="platformInformation.getCurrentPlatformShortcode()"
      [isChrome]="shopSearchHelper.isChrome()"
      [refererId]="refererId"
      (setLocation)="setPoi($event)"
      [disableSearch]="disableSearch"
      (changedLocation)="selectedPoi($event)"
      class="col-12">
    </app-poi-search>
    @if (!shopSearchHelper.formMinified || (!toggleClosed && toggle)) {
      <!-- datepicker group -->
      <app-date-picker
        #datePicker
        formGroupName="dateGroup"
        [subFormGroup]="$any(sf.dateGroup)"
        [fromDate]="{
          year: _bookingParameters.start.getFullYear(),
          month: _bookingParameters.start.getMonth() + 1,
          day: _bookingParameters.start.getDate()
        }"
        [toDate]="{
          year: _bookingParameters.end.getFullYear(),
          month: _bookingParameters.end.getMonth() + 1,
          day: _bookingParameters.end.getDate()
        }"
        (changedDates)="_changedDates($event)"
        class="col-12">
      </app-date-picker>
      <!-- persons -->
      <app-person
        #person
        formGroupName="personGroup"
        [isIncludedOnStart]="isIncludedOnStart"
        [subFormGroup]="$any(sf.personGroup)"
        [maxAllowedChildren]="maxAllowedChildren"
        [maxAllowedPersons]="maxAllowedPersons"
        (changedPersons)="_updatePersonCount($event)"
        [subFormGroupPromocode]="$any(sf.promotionCode)"
        [bookingParameters]="_bookingParameters"
        (changedServiceId)="_changedServiceId($event)"
        [subFormGroupServiceId]="$any(sf.serviceId)"
        [class.d-none]="abTestHidePeople"
        class="col-12">
      </app-person>

      @if (deliveryShop) {
        <div class="form-checkbox pt-2 pb-2">
          <label class="checkbox-wrapper d-inline-flex flex-row align-items-center">
            <input type="checkbox" [formControl]="delivery" />
            <span class="checkmark flex-shrink-0 border"></span>
            <span [innerHTML]="'SHOP_SEARCH.deliverToHotel' | alpitranslate"></span>
          </label>
        </div>
      }

      <!-- promocode -->
      @if (!hidePromocode) {
        <app-promotion-code
          formName="promotionCode"
          [subFormGroup]="$any(sf.promotionCode)"
          [bookingParameters]="_bookingParameters"
          [isIncludedOnStart]="isIncludedOnStart"
          [implementationPage]="implementationPage"
          (changedPromotionCode)="_changedPromoCode($event)"
          (changedCouponCode)="_changedCouponCode($event)"
          class="col-12 col-sm-8 pr-sm-2 search-form-small-fields">
        </app-promotion-code>
      }
      <!-- search button -->
      <div class="col-12" [class.col-sm-4]="!hidePromocode">
        <button
          data-test="search-submit"
          class="btn btn-primary btn-filter btn-block mb-3"
          style="width: 100%; margin-bottom: 1rem"
          type="submit"
          [ngStyle]="submitButtonStyle()">
          <span class="btn-text">
            @if (shopSearchHelper.loading) {
              <app-icon name="circleNotch" />
            } @else {
              @if (deliveryShop && delivery.value) {
                {{
                  'SHOP_SEARCH.formSearchButtonLabelDelivery'
                    | alpitranslate
                      : { price: deliveryShop.price | alpicurrency: currencySerivce.getActualCurrency() }
                }}
              } @else {
                {{ 'SHOP_SEARCH.formSearchButtonLabel' | alpitranslate }}
              }
            }
          </span>
        </button>
      </div>
      <!-- error messages -->
      @if (personCountHelper.touched && sf.personGroup.errors?.adultAndChildrenEmpty) {
        <ul id="person-count-error" class="error error__person-count d-block">
          <li>
            {{ 'SHOP_SEARCH.onePersonRequired' | alpitranslate }}
          </li>
        </ul>
      }
      @if (sf.promotionCode.errors?.promocodeInvalid) {
        <ul id="promotion-code-error" class="error error__person-count d-block">
          <li>
            {{ 'SHOP_SEARCH.formPromotionCodeNotFound' | alpitranslate }}
          </li>
        </ul>
      }
    }
  }
</form>
